export function stickyElement() {
    let $header = $(".header");
    let $parent = $(".sticky-element-wrap");
    let $stickyEl = $(".sticky-element");
    let $stickyElHolder = $stickyEl.find(".holder-for-sticky");
    let windowTop;

    function sticky() {
        windowTop = $(window).scrollTop();
        let $stickyElTop = $stickyEl.offset().top;
        let $headerHeight = $header.innerHeight();
        let $parentHeight = $parent.innerHeight();
        let $parentTop = $parent.offset().top;
        let $stickyElHolderHeight = $stickyElHolder.innerHeight();
        if (windowTop > $stickyElTop - $headerHeight - 20 && window.innerWidth >= 1024) {
            $stickyElHolder.css({
                position: "fixed",
                top: $headerHeight + 20,
            });
        }
        if (windowTop > ($parentHeight + $parentTop - $stickyElHolderHeight - $headerHeight - 20) && window.innerWidth >= 1024) {
            $stickyElHolder.css({
                position: "absolute",
                top: $parentHeight - $stickyElHolderHeight
            });
        }

        if (windowTop > $stickyElTop - $headerHeight - 20 && window.innerWidth <= 1024) {
            $stickyElHolder.css({
                position: "fixed",
                top: $headerHeight
            });
        }
        if (windowTop < $stickyElTop - $headerHeight - 20 ) {
            $stickyElHolder.attr("style", "");

        }

    }

    $(window).on("load scroll", function () {
        sticky();
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/stickyElement.js